import { IProject, ISku } from "@/interfaces";

export const mergeUpdatedSkus = (
  project: Partial<IProject> | undefined,
  updatedSkus: ISku[]
): Partial<IProject> => ({
  ...project,
  stockKeepingUnits: updatedSkus,
});
